module.exports = __webpack_public_path__ + "static/rc-3-32a4d65ac7a9711ba8cdd4eebb1a13c8.jpg";